// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TopBar from './components/TopBar';
import Header from './components/Header';
import Home from './pages/Home';
import Education from './pages/Education';
import Experience from './pages/Experience';
import Contact from './pages/Contact';
import Resume from './pages/Resume';
import translations from './lang';
import Footer from './components/Footer';
import ThemeSwitcherBall from './components/ThemeSwitcherBall'; 
import HoverHint from './components/HoverHint';
import ScrollToTop from './components/ScrollToTop';
import './style.css';

function App() {
  const getInitialLang = () => {
    const cookieLang = document.cookie
      .split('; ')
      .find(row => row.startsWith('lang='));
    if (cookieLang) {
      return cookieLang.split('=')[1];
    } else {
      const browserLang = navigator.language || navigator.userLanguage;
      if (browserLang.startsWith('zh')) return 'zh';
      else return 'en';
    }
  };

  const [lang, setLang] = useState(getInitialLang);

  const getInitialTheme = () => {
    const cookieTheme = document.cookie
      .split('; ')
      .find(row => row.startsWith('theme='));
    if (cookieTheme) {
      return cookieTheme.split('=')[1];
    } else {
      return window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
    }
  };

  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.cookie = `lang=${lang}; path=/; max-age=${60 * 60 * 24 * 30}`;
  }, [lang]);

  useEffect(() => {
    document.cookie = `theme=${theme}; path=/; max-age=${60 * 60 * 24 * 30}`;
    document.documentElement.className = theme; // 给 <html> 加 class="dark" or "light"
  }, [theme]);

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <BrowserRouter>
      <TopBar
        lang={lang}
        setLang={setLang}
        currentTime={time}
        translations={translations}
      />
      <Header lang={lang} translations={translations} />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home lang={lang} />} />
        <Route path="/education" element={<Education lang={lang} />} />
        <Route path="/experience" element={<Experience lang={lang} />} />
        <Route path="/contact" element={<Contact lang={lang} />} />
        <Route path="/resume/:version" element={<Resume lang={lang} />} />
      </Routes>
      <Footer />
      <HoverHint text={lang === 'zh' ? '双击切换日间/夜间模式' : 'Double click to switch theme'}>
      <ThemeSwitcherBall theme={theme} setTheme={setTheme} />
      </HoverHint>
    </BrowserRouter>
  );
}

export default App;


